import Vue from 'vue';
export default Vue.extend({
    props: {
        value: {
            type: [String, Number, Boolean, Object, Array, Function],
            default: null
        },
        separator: { type: Boolean, required: false, default: false },
        title: { type: Boolean, required: false, default: false },
        disabled: { type: Boolean, required: false, default: false },
        custom: { type: Boolean, required: false, default: false },
        focusable: {
            type: Boolean,
            required: false,
            default: true
        },
        paddingless: { type: Boolean, required: false, default: false },
        hasLink: { type: Boolean, required: false, default: false },
        preventActive: { type: Boolean, required: false, default: false },
        active: { type: Boolean, required: false, default: false },
        ariaRole: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        itemClasses() {
            return {
                'dropdown-item': !this.hasLink,
                'disabled': this.disabled,
                'paddingless': this.paddingless,
                'active': (this.$parent.highlightActive && this.isActive && !this.preventActive) || (this.active && !this.preventActive),
                'has-link': this.hasLink
            };
        },
        ariaRoleItem() {
            return this.ariaRole === 'menuitem' || this.ariaRole === 'listitem' ? this.ariaRole : null;
        },
        /**
         * Check if item can be clickable.
         */
        isClickable() {
            return !this.$parent.disabled && !this.separator && !this.disabled && !this.custom;
        },
        isActive() {
            if (this.$parent.selected === null)
                return false;
            return this.value === this.$parent.selected;
        }
    },
    methods: {
        /**
         * Click listener, select the item.
         */
        selectItem() {
            if (!this.isClickable)
                return;
            this.$parent.selectItem(this.value);
            this.$emit('click');
        }
    }
});
